import type { ColumnsType } from 'antd/es/table'

import { hasChildrenColumns } from './tableActions'

export const countVisibleColumns = <T>(columns: ColumnsType<T>): number => {
  let count = 0

  for (const col of columns) {
    if (hasChildrenColumns(col)) {
      count += col.children.filter((child) => {
        const hasTitle =
          'title' in child &&
          child.title !== undefined &&
          child.title !== null &&
          child.title !== ''
        const hasLabel =
          'label' in child &&
          child.label !== undefined &&
          child.label !== null &&
          child.label !== ''

        return hasTitle || hasLabel
      }).length
    } else {
      const hasTitle =
        'title' in col &&
        col.title !== undefined &&
        col.title !== null &&
        col.title !== ''
      const hasLabel =
        'label' in col &&
        col.label !== undefined &&
        col.label !== null &&
        col.label !== ''

      if (hasTitle || hasLabel) {
        count++
      }
    }
  }

  return count
}
